<template>
  <div>
    <nav-bar class="nav-bar" style="z-index: 10; display: " />
    <!-- <side-bar class="side-bar" style="z-index: 10;display: none;"/> -->
    <app-main class="app-main" style="" />
    <app-foot />
  </div>
</template>

<script>
import { AppMain, NavBar, AppFoot } from './components'
export default {
  name: 'MainLayout',
  components: {
    AppMain,
    NavBar,
    AppFoot
  },
  data() {
    return {}
  },
  methods: {},
  mounted() {},
  beforeDestroy() {}
}
</script>

<style scoped>
.nav-bar {
  position: fixed;
  background-color: var(--card, #141c29);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.3);
  width: 100%;
}
.app-main {
  position: static;
}
</style>
